import React from 'react';
import Box from '@mui/material/Box';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import history from '#/history';
import Voca from 'voca';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';


const prettyHeader = name => Voca.titleCase(name).replace('-', ' ');


const ListScript = props => {

    const runScript = props.runScript;
    const data = props.data;
    const tab = props.tab;


    //delete scripts that cannot be executed
    if (runScript){
        delete (data.mailer);
    }

    const handleClick = page => {
        props.setTab(page);
        if (!runScript){
            history.push(`/scripts/${page}`);
        }
    };

    return (
        <AppBar position='static' style={{
            background: 'white',
            width: '80%'
        }}>
            <Container maxWidth='m'>
                <Toolbar disableGutters>

                    <Box sx={{
                        flexGrow: 1,
                        display: {
                            xs: 'none',
                            md: 'flex'
                        }
                    }}>
                        {Object.keys(data).map(name => (
                            <ListItemButton style={ tab === name
                                ? {
                                    height: '100%',
                                    color: 'white',
                                    background: '#002144'
                                }
                                : {
                                    color: '#002144',
                                    background: 'white'
                                }} onClick={() => handleClick(name)}>
                                <ListItemText primary={ prettyHeader(name) } />
                            </ListItemButton>
                        ))}

                    </Box>


                </Toolbar>
            </Container>
        </AppBar>
    );
};


export default ListScript;
